<script>
  import Outlined from "../Outlined.svelte";

  const services = [
    {
      image: '/icon/delivery.png',
      alt: 'Delivery icon',
      text: 'Доставката е 4лв, за поръчка в Костинброд над 80лв е безплатна',
    },
    {
      image: '/icon/money.png',
      alt: 'Money icon',
      text: 'Плаща се в брой, с карта или електронен ваучер',
    },
    {
      image: '/icon/location.png',
      alt: 'Location icon',
      text: 'Услугата се извършва в Костинброд, Голяновци, Драговищица и околията',
    },
  ];
  
</script>
  

<!--  The content is oging to be  -->
<!-- Plan the content -->

<!-- Image with store with text on it -->
<!-- For landing page -->
<div class="bg-blue-600 h-80 flex justify-center text-white text-bold rounded-br-3xl">
  <span class="translate-y-[25%] font-semibold text-3xl">За нас</span>
</div>
<img class="h-80 w-[32rem] max-w-[70%] object-cover relative translate-y-[-50%] m-auto rounded-lg" src="/supermarket.jpg" alt="Store">

<div class="translate-y-[-50%] max-w-2xl m-auto">
  <Outlined>
    Добре дошли в онлайн магазинът на голямото Ванче "Малкото ханче". 
    Тук ще намерите всичко необходимо, което може да получите от физическия магазин, право до вашия дом.
  </Outlined>
</div>

<!-- 3 cards page -->
<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 p-4 md:p-16">
  {#each services as service}
    <div class="h-40 bg-green-600 rounded-3xl shadow-lg cursor-pointer flex justify-center items-center p-4">
      <img src={service.image} alt={service.alt} class="w-full rounded-t-lg h-16 max-h-16 md:max-h-32 md:h-32 object-contain invert" />

      <div class="w-full text-center flex items-center justify-center pr-4">
        <span class="text-white font-semibold text-lg md:text-xl">{service.text}</span>
      </div>
    </div>
  {/each}
</div>


<!-- Social media bar -->
<!-- Facebook -->


<footer class="grid md:grid-cols-4 bg-blue-400 text-white p-4">
  <div class="col-span-3">
    <div>
      <p>Име на фирмата: Стронгпласт ЕООД</p>
      <p>Град: Костинброд</p>
      <p>Адрес: АЛ. СТАМБОЛИЙСКИ 3</p>
      <p>ДДС ид. No.: BG175352689</p>
      <p>МОЛ: Иванка Благоева</p>
    </div>
  </div>
  <div class="col-start-4 col-span-1 h-40 w-full">
    Контакт
    <a class="mt-2 w-12 h-12 cursor-pointer block" target="_blank" href="https://facebook.com/profile?id=100093328096155">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
        <style type="text/css">
          .st0{fill:url(#SVGID_1_);}
          .st1{fill:#FFFFFF;}
        </style>
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-277.375" y1="406.6018" x2="-277.375" y2="407.5726" gradientTransform="matrix(40 0 0 -39.7778 11115.001 16212.334)">
          <stop  offset="0" style="stop-color:#0062E0"/>
          <stop  offset="1" style="stop-color:#19AFFF"/>
        </linearGradient>
        <path class="st0" d="M16.7,39.8C7.2,38.1,0,29.9,0,20C0,9,9,0,20,0s20,9,20,20c0,9.9-7.2,18.1-16.7,19.8l-1.1-0.9h-4.4L16.7,39.8z"
          />
        <path class="st1" d="M27.8,25.6l0.9-5.6h-5.3v-3.9c0-1.6,0.6-2.8,3-2.8h2.6V8.2c-1.4-0.2-3-0.4-4.4-0.4c-4.6,0-7.8,2.8-7.8,7.8V20
          h-5v5.6h5v14.1c1.1,0.2,2.2,0.3,3.3,0.3c1.1,0,2.2-0.1,3.3-0.3V25.6H27.8z"/>
      </svg>
    </a>
    <a href="tel:+359879399088">0879399088</a>
  </div>
</footer>
